import axios from "axios";
import { configUrlsAmbiente } from "./configUrlsAmbiente";
const configUrl = configUrlsAmbiente();

let ApiCep = axios.create({
  baseURL: configUrl.REACT_APP_API_CEP,
});

export { ApiCep };
